/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldcity3Inputs */

const en_placewebfieldcity3 = /** @type {(inputs: Placewebfieldcity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_placewebfieldcity3 = /** @type {(inputs: Placewebfieldcity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Placewebfieldcity3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldcity3 = /** @type {((inputs?: Placewebfieldcity3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldcity3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldcity3(inputs)
	return de_placewebfieldcity3(inputs)
});
export { placewebfieldcity3 as "placeWebFieldCity" }